type PostTypesType = {
    bible: 0,
    prayer: 1,
    fellowship: 2,
    bibleQuestion: 3,
    bibleVerse: 4,
    bibleChallenge: 5,
}
export const PostTypes: PostTypesType = {
    bible: 0,
    prayer: 1,
    fellowship: 2,
    bibleQuestion: 3,
    bibleVerse: 4,
    bibleChallenge: 5,
}

export type PostTypesValues = typeof PostTypes[keyof typeof PostTypes]

export const AllPostTypes: PostTypesValues[] = Array.from(Object.values(PostTypes));

export const PostTypesQuestions:{ [key in PostTypesValues]: string } = {
    [PostTypes.bible]: 'Bible',
    [PostTypes.bibleQuestion]: 'Bible Question',
    [PostTypes.bibleVerse]: 'Bible Verse',
    [PostTypes.bibleChallenge]: 'Bible Challenge',
    [PostTypes.prayer]: 'Prayer',
    [PostTypes.fellowship]: 'Fellowship',
}

export default PostTypes;